<template>
  <main class="relative">
    <div class="absolute inset-0 w-full h-full">
      <img
        src="@/assets/media/TruPath-4.jpg"
        alt=""
        class="w-full h-full object-cover"
      />
      <div
        class="absolute inset-0 bg-accent opacity-80 mix-blend-multiply"
        aria-hidden="true"
      />
    </div>
    <Container full>
      <slot></slot>
    </Container>
  </main>
</template>

<script>
import Container from "@/components/base/Container";

export default {
  components: {
    Container,
  },
};
</script>
